import { useLocation } from 'react-router-dom';
import { getOgpPathWithinCompany } from './get-ogp-path-within-company';

export const useOgpPathWithinCompany = (): string => {
  const { pathname } = useLocation();
  return getOgpPathWithinCompany(pathname);
};
